<template>
    <li class="lee-menu-item" :class="{active:exp}"><span @click="toggle(item)"><i v-if="item.child&&!exp">+</i><i v-else>-</i>{{item.text}}</span>
        <transition name="leetran" @enter="enter" @after-enter="afterenter" @leave="leave" @after-leave="afterleave">
            <ul class="lee-menu-sub" v-show="exp" v-if="item.child">
                <lee-menu-item v-for="(items, index) in item.child" :item="items" :key="index"></lee-menu-item>
            </ul>
        </transition>
    </li>
</template>
<script>
export default {
    name: 'LeeMenuTree',
    inheritAttrs: false,
    data() {
        return {
            exp: false
        }
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        toggle(item) {
            if (item.child && item.child.length) {
                this.exp = !this.exp
            }
        },
        enter(el) {
            var h = el.scrollHeight
            el.style.setProperty('--h', h + 'px')
        },
        afterenter(el) {
            el.removeAttribute('style')
        },
        leave(el) {
            var h = el.scrollHeight
            el.style.setProperty('--h', h + 'px')
        },
        afterleave(el) {
            el.style.setProperty('--h', '')
        }
    },
    computed: {

    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        }
    }
};
</script>
<style scoped>
.lee-menu-item {
    line-height: 40px;
    border-bottom: solid 1px #ededed;
}



.lee-menu-item:last-child {
    border-bottom: none;
}

.lee-menu-item span {
    line-height: 40px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    transition: all .5s;border-bottom: solid 1px transparent
}
.lee-menu-item.active>span{border-bottom: solid 1px #ededed}

.lee-menu-item span i {
    background: #46bd87;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    color: #fff;
    line-height: 12px;
    text-align: center;
    border-radius: 5px;
}

.lee-menu-sub {
    padding: 0px;
    margin: 0px;
    list-style: none;
    padding-left: 15px;
    overflow: hidden;
}
.leetran-enter-active {
    animation: my-in .3s ease-in-out;
}

.leetran-leave-active {
    animation: my-out .3s ease-in-out;
}
@keyframes my-in {
    0% {
        height: 0
    }

    100% {
        height: var(--h);
    }
}

@keyframes my-out {
    0% {
        height: var(--h);
    }

    100% {
        height: 0
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeMenuItem.vue